import api from "src/api/axiosInstance";
import { setOrderReviews, setOrderReviewsError, setOrderReviewsLoading } from "src/store/slices/orderReviews-slice";
import { store } from "src/store/store";

/**
 * Fetches order reviews from the API
 * @param {number} page - Page number for pagination (default: 1)
 * @param {number} limit - Number of reviews per page (default: 12)
 * @returns {Promise<Array>} - Array of order reviews
 */
export const fetchOrderReviews = async (page = 1, limit = 12) => {
  store.dispatch(setOrderReviewsLoading());
  try {
    const response = await api.get(`/order-review?page=${page}&limit=${limit}`);
    
    // Sort reviews: markAsHelpful true first, then false
    const sortedReviews = response.data ? response.data.sort((a, b) => {
      if (a.markAsHelpful === b.markAsHelpful) return 0;
      return a.markAsHelpful ? -1 : 1;
    }) : [];
    
    store.dispatch(setOrderReviews(sortedReviews));
    return sortedReviews;
  } catch (error) {
    console.error("Error fetching order reviews:", error);
    store.dispatch(setOrderReviewsError(error.message || "Failed to fetch order reviews"));
    return [];
  }
};